export default {
    data() {
        return {
            fromRoutePath: null
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fromRoutePath = from.fullPath === '/' ? null : from.fullPath
            next()
        })
    },

    computed: {
        // it would perform better if the fallback was a predefined value in data()
        // but this approach is more handy
        backlink() {
            return (fallback) => {
                return this.fromRoutePath && this.fromRoutePath != '/' ? this.fromRoutePath : (fallback || '/')
            }
        }
    }
}
